import { useFormContext, DeepMap, FieldError } from "react-hook-form";
import {
  FieldSchema,
  IArrayValidation,
  IValidation,
  isArrayFieldSchema,
  isFileFieldSchema,
  isFileManagementFieldSchema
} from "@generation/core";
import { IsRequiredValidation } from "./IsRequiredValidation";
import { FileAbstractValidation } from "./FileAbstractValidation";

const getError = (
  name: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: DeepMap<Record<string, any>, FieldError> | undefined
): { type: string | null; message: string | null } | null => {
  let errorPath = errors;
  let localName = name;

  while (localName !== "") {
    if (!errorPath) {
      return null;
    }

    if (localName.startsWith(".")) {
      localName = localName.substring(1);
    }

    const matchArray = localName.match(/\[(.*?)\]/);
    if (localName.startsWith("[") && matchArray) {
      errorPath = errorPath[matchArray[1]];

      localName = localName.substr(Number(matchArray[1].length) + 2);
    } else {
      //get name till [ or . or evertthing
      const matchName = localName.match(/^([^[.]*)/);
      if (matchName) {
        errorPath = errorPath[matchName[0]];

        localName = localName.substring(matchName[0].length);
      }
    }
  }

  if (!errorPath) {
    return null;
  }

  return {
    message: errorPath.message,
    type: errorPath.type
  };
};

export const useErrorMessage = (
  name: string,
  field: FieldSchema,
  validations: IValidation[] | IArrayValidation[] | null
): string | null | undefined => {
  const { formState } = useFormContext();

  let localValidations = [...(validations ?? []), new IsRequiredValidation()];

  const error = getError(name, formState.errors);

  if (!error) {
    return null;
  }

  if (
    (isFileFieldSchema(field) && field.showValidationMessageBelowFile === true) ||
    isFileManagementFieldSchema(field)
  ) {
    localValidations = localValidations.filter((item) => !(item instanceof FileAbstractValidation));
  }

  let label = field.label;

  if (isArrayFieldSchema(field)) {
    label = field.addLabel;
  }

  return localValidations?.find((item) => item.key === error.type)?.message(label ?? "") ?? error.message;
};
